import React from "react";
import { connect } from "react-redux";
import { actionCreators } from "./redux/sagas/clientProfileSearch/clientProfileSearch";
import PropTypes from "prop-types";
import HandsonTable from "../../../components/handsonTable/handsonTable";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
class ClientProfileSearch extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.fetchCurrentUser(this.props.currentUser);
  }
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      displayValue: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    let value = event.target.value.replace(/\s+/g, ' ')
    if(value === " " && this.state.value === "") value = ""
    this.setState({ value });
  }

  handleSubmit(event) {
    event.preventDefault();
    let trimmedValue = this.state.value.trim()
    if (trimmedValue !== "") {
      this.props.searchClients(trimmedValue);
      this.setState({
        displayValue: trimmedValue,
        value: trimmedValue
      });
    }
  }

  renderTable(){
    const tableInfo = this.props.searchResults.tableInfo
    if(tableInfo.data){
      return tableInfo.data.length
        ? <HandsonTable
          data={tableInfo.data}
          columns={tableInfo.colHeaders}
          colHeaders={tableInfo.columns}
          width={1350}
          height={800}
          columnSorting
          stretchH="all"
        />
        : <div className="error--medium">No data found</div>;
    }
  }
  render() {
    return (
      <div>
        <div className="search-title">
          {this.props.showTable && !this.props.tableLoading ? (
            <p>
              Displaying the top {this.props.searchResults.tableInfo.data.length} results for {this.state.displayValue}
            </p>
          ) : (
            <p>Search for user by name or email</p>
          )}
        </div>
        <form onSubmit={this.handleSubmit}>
          <input className="text" type="text" value={this.state.value} onChange={this.handleChange} />
          <input className="submit" type="submit" value="GO!" />
        </form>
        <div style={{ width: "650px" }}>
          {this.props.showTable &&
            this.props.tableLoading
              ? <LoadingAnimation />
              : this.renderTable()
          }
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    userParams: state.clientProfileSearch.currentUser,
    searchResults: state.clientProfileSearch.searchResults,
    showTable: state.clientProfileSearch.showTable,
    tableLoading: state.clientProfileSearch.tableLoading
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    searchClients: actionCreators.searchClients
  }
)(ClientProfileSearch);

ClientProfileSearch.propTypes = {
  currentUser: PropTypes.object,
  fetchCurrentUser: PropTypes.func,
  searchClients: PropTypes.func,
  searchResults: PropTypes.object,
  showTable: PropTypes.bool,
  tableLoading: PropTypes.bool
};
